import {
  ParseOptions,
  safeQueryString,
  StringifyOptions
} from '@utmost.co/utmost-design-system/src/utils/safeQueryString';

export const queryStringParse = <T>(query: string, options?: ParseOptions): T =>
  safeQueryString.fromString(query, options) as unknown as T;

export const queryStringStringify = <T extends Record<string, any>>(query: T, options?: StringifyOptions): string =>
  safeQueryString.toString(query, options);
